module.exports = __webpack_public_path__ + "img/banner-commerce-debut.c8b5b58a.webp";